export default "__VITE_ASSET__NiS$$4L6__"